// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"SelectSubscriptionPeriod_labelWrapper__MVh6X","labelText":"SelectSubscriptionPeriod_labelText__lCiq8","active":"SelectSubscriptionPeriod_active__Ksilp"};